function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "New-Icon/Info/On_White",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Safespace",
  x: 0,
  y: 0,
  width: 20,
  height: 20
}), /*#__PURE__*/React.createElement("g", {
  id: "info",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#48A9A1",
  opacity: 0.2,
  cx: 10.92,
  cy: 8.99,
  r: 8.69
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.92,4.71 L10.92,6.84 L8.5,6.84 L8.5,4.71 L10.92,4.71 Z M8.58,8.28 L10.84,8.28 L10.84,15.88 L8.58,15.88 L8.58,8.28 Z",
  id: "Shape",
  fill: "#48A9A1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.72,19.7000055 C5.99804001,19.7040456 2.64031832,17.4651044 1.21318177,14.0276222 C-0.213954772,10.59014 0.570687919,6.6314169 3.20108112,3.99816147 C5.83147432,1.36490603 9.78934174,0.575958506 13.228374,1.99935578 C16.6674062,3.42275306 18.91,6.77803781 18.91,10.5 C18.9045018,15.5748384 14.7948294,19.6889827 9.72,19.7000055 Z M9.72,2.30999387 C6.40159305,2.30595562 3.40787591,4.30233765 2.13610758,7.36737376 C0.864339255,10.4324099 1.56526068,13.9617997 3.91173048,16.3082695 C6.25820028,18.6547393 9.78759013,19.3556607 12.8526262,18.0838924 C15.9176624,16.8121241 17.9140444,13.818407 17.9100061,10.5 C17.9100061,8.32787695 17.0471275,6.2447184 15.5112045,4.70879546 C13.9752816,3.17287252 11.8921231,2.30999387 9.72,2.30999387 Z",
  id: "Shape",
  fill: "#555150"
})));

var SvgHint = function SvgHint(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHint, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Hint.6f7f5f70.svg";
export { ForwardRef as ReactComponent };